const dpm = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/boy.webp"
const dpf = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/girl.webp"

const cover = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Administration/Principal_office/adstaff.webp"


export const office_admin_staffs = [
  {
    id: '1',
    cover: cover,
    dp: dpm,
    name: 'Mr.B.Saravanan',
    quali: 'B.Sc.,M.A.,M.Lib.Sci.,',
    Designation: 'PA to Principal',
    phn: '9443978059',
    email: 'manohari.aravindhakshan@gmail.com'
  },

  {
    id: '2',
    cover: cover,
    dp: dpm,
    name: 'Mr.Al.Prabahar',
    quali: 'B.com.,',
    Designation: 'Bursar',
    phn: '9443012999',
    email: 'prabaharal@gmail.com'
  },
  {
    id: '3',
    cover: cover,
    dp: dpm,
    name: 'Mr.V.Eswaran',
    quali: 'M.A (History)',
    Designation: 'Superintendent',
    phn: '9952568084',
    email: 'mksamyaccet2015@gmail.com'
  },
  {
    id: '4',
    cover: cover,
    dp: dpf,
    name: 'Mrs.A.Badhurunnishal',
    quali: 'M.A.,B.Ed.,M.Phil',
    Designation: 'Superintendent',
    phn: '9445381481',
    email: 'badhurunnisharahumathulla@gmail.com'
  },
  {
    id: '5',
    cover: cover,
    dp: dpm,
    name: 'Mr.A.Mathurapandian',
    quali: 'Hr.Sec.,NTC,NAC',
    Designation: 'Superintendent',
    phn: '9842526149',
    email: 'ganesan1451065@gmail.com'
  },
  {
    id: '6',
    cover: cover,
    dp: dpm,
    name: 'Mr.S.Abdul Majith',
    quali: 'SSLC',
    Designation: 'Superintendent',
    phn: '7639636624',
    email: 'samamajith1990@gmail.com'
  },
  {
    id: '7',
    cover: cover,
    dp: dpf,
    name: 'Mrs.M.Vishnu Priya',
    quali: 'B.Com',
    Designation: 'Superintendent',
    phn: '8838165526',
    email: 'priyaworld333@gmail.com'
  },
  {
    id: '8',
    cover: cover,
    dp: dpf,
    name: 'Mrs.S.Sugirtha',
    quali: 'B.Litt,M.A (Tamil)',
    Designation: 'Assistant',
    phn: '9677704237',
    email: 'adhisankar49@gmail.com'
  },
  {
    id: '9',
    cover: cover,
    dp: dpf,
    name: 'Mrs.B.Akila',
    quali: 'M.Com.,B.Li.Sc.,',
    Designation: 'Assistant',
    phn: '9894053646',
    email: 'akilarhiru2012@gmail.com'
  },
  {
    id: '10',
    cover: cover,
    dp: dpf,
    name: 'Ms.S.Benazir Begum',
    quali: 'B.A.,(English)',
    Designation: 'Assistant',
    phn: '8610995982',
    email: 'benaziraccet@gmail.com'
  },
  {
    id: '11',
    cover: cover,
    dp: dpm,
    name: 'Mr.K.Ganiselvam',
    quali: 'M.A,B.Ed.,',
    Designation: 'Assistant',
    phn: '6382879145',
    email: 'ganikalaiyur90@gmail.com'
  },
  {
    id: '12',
    cover: cover,
    dp: dpf,
    name: 'Mrs.A.Nivetha',
    quali: 'B.Sc.,(Chemistry)',
    Designation: 'Assistant',
    phn: '866757092',
    email: 'balagironaldhinho@gmail.com'
  },
  {
    id: '13',
    cover: cover,
    dp: dpm,
    name: 'Mr.S.Sheik Abdullah',
    quali: 'B.E,(Aeronautical Engineering)',
    Designation: 'Assistant',
    phn: '9677474525',
    email: 'sheikabdullah.aero@gmail.coom'
  },
  {
    id: '14',
    cover: cover,
    dp: dpm,
    name: 'Mr.M.Saravanakumar',
    quali: 'B.Sc.,(Chemistry)',
    Designation: 'Assistant',
    phn: '',
    email: ''
  },
  {
    id: '15',
    cover: cover,
    dp: dpm,
    name: 'Mr.N.Balaji',
    quali: 'B.E(EEE)',
    Designation: 'Assistant',
    phn: '',
    email: ''
  },
  {
    id: '16',
    cover: cover,
    dp: dpf,
    name: 'Mrs.M.Sumathi',
    quali: 'B.A.,(History)',
    Designation: 'Steno Typist',
    phn: '9629554985',
    email: 'msumathi2401@gmail.com'
  },
  {
    id: '17',
    cover: cover,
    dp: dpf,
    name: 'Ms.M.Mahalakshmi',
    quali: 'Hr.Sec.,',
    Designation: 'Steno Typist',
    phn: '9751815926',
    email: 'marimahendran73@gmail.com'
  },
  {
    id: '18',
    cover: cover,
    dp: dpf,
    name: 'Ms.K.Banupriya',
    quali: 'M.Sc.,(Computer Science)',
    Designation: 'Steno Typist',
    phn: '9943809183',
    email: 'prasanthjai333@gmail.com'
  },
  {
    id: '19',
    cover: cover,
    dp: dpm,
    name: 'Mr.R.Suresh',
    quali: 'B.Tech.,(Information Technology)',
    Designation: 'Assistant',
    phn: '9894341456',
    email: 'sugirthajesus37@gmail.com'
  },
  {
    id: '20',
    cover: cover,
    dp: dpm,
    name: 'Mr.M.Balamurali',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: 'murali.bala786@gmail.com'
  },
  {
    id: '21',
    cover: cover,
    dp: dpf,
    name: 'Mrs.A.Jebakani',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: 'jebakanisuthish@gmail.com'
  },
  {
    id: '22',
    cover: cover,
    dp: dpf,
    name: 'Mrs.P.Sarala',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: 'saralarajkumar77@gmail.com'
  },
  {
    id: '23',
    cover: cover,
    dp: dpf,
    name: 'Ms.R.Muthulakshmi',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: 'visu3579@gmail.com'
  },
  {
    id: '24',
    cover: cover,
    dp: dpm,
    name: 'Mr.PL.Karthikeyan',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: ''
  },
  {
    id: '25',
    cover: cover,
    dp: dpf,
    name: 'Ms.K.Devi Abirami',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: ''
  },
  {
    id: '26',
    cover: cover,
    dp: dpm,
    name: 'Mr.P.Giridharan',
    quali: '',
    Designation: '',
    phn: '',
    email: ''
  },
  {
    id: '27',
    cover: cover,
    dp: dpf,
    name: 'Ms.T.Divya',
    quali: '',
    Designation: 'Typist',
    phn: '',
    email: ''
  },
  {
    id: '28',
    cover: cover,
    dp: dpm,
    name: 'Mr.G.Thiagarajan',
    quali: '',
    Designation: '',
    phn: '',
    email: ''
  },
  {
    id: '29',
    cover: cover,
    dp: dpm,
    name: 'Mr.V.Saravanakumar',
    quali: '',
    Designation: 'Junior Assistant',
    phn: '',
    email: ''
  },
  {
    id: '30',
    cover: cover,
    dp: dpf,
    name: 'Ms.J.Anushiya',
    quali: '',
    Designation: 'Typist',
    phn: '',
    email: 'sugunabe1844@gmail.com'
  },
  {
    id: '31',
    cover: cover,
    dp: dpm,
    name: 'Mr.B.Periyasamy',
    quali: '',
    Designation: 'Record Asst.',
    phn: '',
    email: 'periyasamy5500@gmail.com'
  },
  // {
  //   id:'32',   
  //   cover: cover,
  //   dp: dpf,
  //   name:'Mrs.T.Amutha',
  //   quali:'',
  //   Designation:'Library Attender',
  //   phn:'',
  //   email:''
  // },
  {
    id: '33',
    cover: cover,
    dp: dpf,
    name: 'Mrs.S.Jayanthi',
    quali: '',
    Designation: 'Office Asst.(SG)',
    phn: '',
    email: 'sjayanthi682@gmail.com'
  },
  {
    id: '34',
    cover: cover,
    dp: dpm,
    name: 'Mr.P.Sivasankar',
    quali: '',
    Designation: 'Office Asst.(SG)',
    phn: '',
    email: 'jayanthan2004@gmail.com'
  },
  {
    id: '35',
    cover: cover,
    dp: dpm,
    name: 'Mr.S.Sembulingam',
    quali: '',
    Designation: 'Office Asst.(SG)',
    phn: '',
    email: ''
  },

  {
    id: '46',
    cover: cover,
    dp: dpm,
    name: 'Mr.Dharmalingam',
    quali: '',
    Designation: 'Sargent',
    phn: '',
    email: ''
  },

  {
    id: '36',
    cover: cover,
    dp: dpm,
    name: 'Mr.G.Velusamy',
    quali: '',
    Designation: 'Watchman(SG)',
    phn: '',
    email: ''
  },
  {
    id: '37',
    cover: cover,
    dp: dpm,
    name: 'Mr.S.Hariharan',
    quali: '',
    Designation: 'Watchman(SG)',
    phn: '',
    email: ''
  },
  {
    id: '38',
    cover: cover,
    dp: dpm,
    name: 'Mr.S.Murugan',
    quali: '',
    Designation: 'Watchman(SG)',
    phn: '',
    email: ''
  },
  {
    id: '39',
    cover: cover,
    dp: dpf,
    name: 'Mr.T.Vekatesan',
    quali: '',
    Designation: 'Watchman(SG)',
    phn: '',
    email: ''
  },
  {
    id: '40',
    cover: cover,
    dp: dpm,
    name: 'Mr.K.Palani',
    quali: '',
    Designation: 'Watchman(SG)',
    phn: '',
    email: ''
  },
  {
    id: '41',
    cover: cover,
    dp: dpm,
    name: 'Mr.PL.Vellaichamy',
    quali: '',
    Designation: 'Sweeper(SG)',
    phn: '',
    email: ''
  },
  {
    id: '42',
    cover: cover,
    dp: dpm,
    name: 'Mr.A.Nagarajan',
    quali: '',
    Designation: 'Sweeper(SG)',
    phn: '',
    email: ''
  },
  // {
  //   id:'43',   
  //   cover: cover,
  //   dp: dpm,
  //   name:'Mr.M.Nallamani',
  //   quali:'',
  //   Designation:'Marker(SG)',
  //   phn:'',
  //   email:''
  // },
  {
    id: '44',
    cover: cover,
    dp: dpm,
    name: 'Mr.T.Parthiban',
    quali: '',
    Designation: 'Cleaner',
    phn: '',
    email: ''
  },
  {
    id: '45',
    cover: cover,
    dp: dpf,
    name: 'Mrs.K.Banupriya',
    quali: '',
    Designation: 'Steno Typist',
    phn: '',
    email: ''
  },
];

